import axios from "axios";
import { apiUrl, apiTimeout } from "./config";

const api = axios.create({
  baseURL: apiUrl,
  timeout: apiTimeout,
});

export default api;
